import * as ACTION_TYPES from './types';

export function hideContextMenu() {
  return {
    type: ACTION_TYPES.CONTEXT_MENU_HIDE,
    payload: 1,
  };
}


export function showContextMenu(x, y, type, menuArgs) {
  return {
    type: ACTION_TYPES.CONTEXT_MENU_SHOW,
    payload: {
      location: {
        x,
        y,
      },
      type,
      menuArgs,
    },
  };
}
